import React, { useState, useEffect, useContext } from 'react';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import ManagePocForm from 'components/brandActivation/managePocForm/managePocForm';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const ManageAddPoc = ({
  match,
  addPoc,
  pocById,
  editPoc,
  getPocById,
  history,
}) => {
  const { id } = useParams();
  const { baseUrl } = useContext(BaseUrl);

  const [isFiled, setIsFiled] = useState(false);
  const pocInputs = {
    pocDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [pocData, setCorporateData] = useState(pocInputs);
  const [siteId, setSiteId] = useState();
  const [clientId, setClientId] = useState();
  useEffect(() => {
    if (id) {
      (async () => {
        await getPocById(id);
      })();
    }
  }, [id]);

  const handleSubmit = async () => {
    const { pocDetails } = pocData;
    if (pocDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      if (id) {
        if (pocDetails.name !== '') {
          const res = await editPoc(pocDetails);
          if (res) {
            setIsModal(true);
          }
        }
      } else {
        if (pocDetails.name !== '') {
          const res = await addPoc(pocDetails);
          if (res) {
            setIsModal(true);
          }
        }
      }
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.goBack();
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  const handlePocSubmit = (val) => {
    setCorporateData({ ...pocData, pocDetails: val });
  };

  useEffect(() => {
    setSiteId(match.params.siteId);
    setClientId(match.params.clientId);
  }, [match.params.siteId, match.params.clientId]);

  return (
    <Layout
      title={id ? localization.editPoc : localization.addPoc}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkUrl={`${baseUrl}/brand-activation/corporate-client/poc/${match.params.siteId}/${match.params.clientId}`}
    >
      <ManagePocForm
        handleValue={handlePocSubmit}
        pocById={id ? pocById : null}
        id={id ? id : null}
        siteId={siteId}
        clientId={clientId}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.pocSucces}</h5>
          <Button onClick={handleModalHide} className="mb-4">
            {localization.pocList} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

ManageAddPoc.propTypes = {};

export default ManageAddPoc;
